import { useEffect, useState } from "react";

/** Matches Tailwind `max-lg` — mobile/tablet below the desktop nav breakpoint. */
export const MOBILE_LG_QUERY = "(max-width: 1023px)";

function readMediaQuery(query) {
  return typeof window !== "undefined" && window.matchMedia(query).matches;
}

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => readMediaQuery(query));

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const update = () => setMatches(mediaQuery.matches);
    update();
    mediaQuery.addEventListener("change", update);
    return () => mediaQuery.removeEventListener("change", update);
  }, [query]);

  return matches;
}
